<template>
    <div class="fin-mx-14">
        <h1 class="crm-h1 mb-5">{{ fullName }} Profile</h1>

        <div class="fin-flex fin-space-x-4 fin-w-full fin-mt-20">
            <div class="fin-w-3/12 fin-shadow fin-bg-white">
                <div class="">

                    <el-menu default-active="profilePage" @select="loadMenuItem">
                        <el-menu-item index="userProfile">
                            <font-awesome-icon :icon="['fas', 'user-circle']"/>
                            <span>My Profile</span>
                        </el-menu-item>

                        <el-menu-item index="userPassword">
                            <font-awesome-icon :icon="['fas', 'unlock-alt']"/>
                            <span>Change Password</span>
                        </el-menu-item>

                        <el-menu-item index="userSettings">
                            <font-awesome-icon :icon="['fas', 'cog']"/>
                            <span>App Settings</span>
                        </el-menu-item>

                        <el-menu-item v-if="Ambition.hasRoleOrPermission(['super administrator', 'administrator', 'manager', 'broker', 'referrer'])" index="userAffiliateSettings">
                            <font-awesome-icon :icon="['fas', 'envelope']"/>
                            <span>Affiliate Settings</span>
                        </el-menu-item>

                        <el-menu-item v-if="!isReferrer || isAcrReferrer" index="userLenderSettings">
                            <font-awesome-icon :icon="['fas', 'cog']"/>
                            <span>Lender Settings</span>
                        </el-menu-item>

                        <el-menu-item index="userNotifications">
                            <font-awesome-icon :icon="['fas', 'bell']"/>
                            <span>Notification Settings</span>
                        </el-menu-item>

                        <el-menu-item index="userLogins">
                            <font-awesome-icon :icon="['fas', 'lock']"/>
                            <span>My Sign-Ins</span>
                        </el-menu-item>

                        <el-menu-item index="TicketIndex">
                            <font-awesome-icon :icon="['fas', 'ticket']"/>
                            <span>{{
                                    Ambition.hasRoleOrPermission(['super administrator', 'administrator', 'manager']) ? 'Tickets' : 'My Tickets'
                                }}</span>
                        </el-menu-item>
                    </el-menu>
                </div>
            </div>

            <div class="fin-w-9/12">
                <div v-if="activeMenu === 'TicketIndex'">
                    <component
                        class="fin-w-full fin-p-5 fin-bg-white fin-block fin-shadow"
                        :is="activeMenu"
                        v-bind:tenant="tenant"
                        v-bind:priority-options="Ambition.getGlobal('tenant.ticketPriorityOptions')"
                        v-bind:status-options="Ambition.getGlobal('tenant.ticketStatusOptions')"
                        v-bind:category-options="Ambition.getGlobal('tenant.ticketCategoryOptions')"
                        v-bind:admin-category-options="Ambition.getGlobal('tenant.adminTicketCategoryOptions')"
                        v-bind:tenant-auth-user="userProfile"
                        v-bind:is-tenant="true"
                        v-bind:has-permissions="Ambition.hasRoleOrPermission(['super administrator', 'administrator', 'manager'])"
                    ></component>
                </div>

                <div class="fin-w-full fin-block fin-shadow fin-bg-white" v-else>
                    <component
                        class="fin-w-full"
                        :is="activeMenu"
                        v-bind:sources="sources"
                        v-bind:lead-types="leadTypes"
                        v-bind:tenant="tenant"
                        v-bind:priority-options="Ambition.getGlobal('tenant.ticketPriorityOptions')"
                        v-bind:status-options="Ambition.getGlobal('tenant.ticketStatusOptions')"
                        v-bind:category-options="Ambition.getGlobal('tenant.ticketCategoryOptions')"
                        v-bind:admin-category-options="Ambition.getGlobal('tenant.adminTicketCategoryOptions')"
                    ></component>
                </div>
            </div>

        </div>
    </div>
</template>

<script>
import userProfile from "@shared/components/user/userProfile.vue"
import userPassword from "@shared/components/user/userPassword.vue"
import userSettings from "@shared/components/user/userSettings.vue"
import userAffiliateSettings from "@shared/components/user/userAffiliateSettings.vue"
import userLenderSettings from "@shared/components/user/userLenderSettings.vue"
import userNotifications from "@shared/components/user/userNotifications.vue"
import userLogins from "@shared/components/user/userLogins.vue"
import moment from 'moment';

export default {
    name: "ProfilePage",
    components: {
        userProfile,
        userPassword,
        userSettings,
        userAffiliateSettings,
        userLenderSettings,
        userNotifications,
        userLogins,
    },
    props: {
        user: {
            type: Object,
            required: true,
        },
        timezones: {
            type: Array,
            required: true
        },
        sources: {
            type: Array,
            required: false
        },
        leadTypes: {
            type: Array,
            required: false
        },
        tenant: {
            required: false
        },
        token: {
            type: String,
            required: true
        },
    },
    data() {
        return {
            activeMenu: "userProfile",
            affiliateActive: true
        }
    },
    computed: {
        userProfile: {
            get() {
                return this.$store.getters['user/user']
            },
            set(profile) {
                this.$store.dispatch('user/setUser', profile)
            }
        },
        fullName() {
            if (this.userProfile.first_name && this.userProfile.last_name) {
                return this.userProfile.first_name + ' ' + this.userProfile.last_name + '\'s'
            } else if (this.userProfile.first_name && !this.userProfile.last_name) {
                return this.userProfile.first_name + '\'s'
            }
        },
        isReferrer: function () {
            let roles = this.$store.state.user_roles.roles
            let referrer = roles.find(item => {
                if (item.name === "referrer") {
                    return item
                }
            })
            return !!referrer
        },
        isAcrReferrer() {
            return Ambition.User.isAcrReferrer
        },
    },
    mounted() {
        // let tab = this.$route.path.split("/").pop()
        // switch (tab) {
        //     case 'tickets':
        //         this.activeMenu = 'TicketIndex'
        //         break;
        //     default:
        //         break;
        // }
    },
    methods: {
        loadMenuItem(activeMenu) {
            this.activeMenu = activeMenu
        }
    },

    watch: {
        user: {
            handler(user) {
                this.userProfile = user
            },
            immediate: true,
            deep: true,
        },
        timezones: {
            handler(timezones) {
                this.$store.dispatch('user/setTimezones', timezones)
            },
            immediate: true,
            deep: true,
        },
        token: {
            handler(token) {
                this.$store.dispatch('user/setToken', token)
            },
            immediate: true,
            deep: true,
        },
    }
}
</script>

<style lang="scss" scoped>

.profile-page {
    padding-top: 75px;

    .section-left {
        background: #ffffff;
        height: 100%;
        box-shadow: 0 0 5px 0px #c1c1c1;

        .el-menu {
            border-right: none;
        }

        .profile-image {
            padding: 20px;
            background: #ffffff;

            .profile-image-wrapper {
                .image-wrapper {
                    margin-top: -107.5px;
                }
            }
        }
    }

    .section-right {
        background: #ffffff;
        height: 100%;
        box-shadow: 0 0 5px 0px #c1c1c1;
    }

    .notification-body-container .notifications-container {
        height: 480px;
        overflow-y: scroll;
    }

    .notification-body-container .notifications-container.el-loading-parent--relative {
        overflow: hidden;
    }

    .amb-notification-card {
        background-color: #f3f3f3;
    }
}
</style>
